export const BUDGET_DISTRIBUTION_METHOD = {
    CUSTOM: 'CUSTOM',
    FULLY_SHARED: 'FULLY_SHARED',
};

export const isCampaignPartOfFullySharedBudget = budgetDistributionMethod =>
    budgetDistributionMethod === BUDGET_DISTRIBUTION_METHOD.FULLY_SHARED;
